// src/components/auth/ProtectedRoute.jsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSessionContext } from "../contexts/session-context";

export default function ProtectedRoute() {
    const { session } = useSessionContext();
    const location = useLocation();

    const path = location.pathname || "/";
    const allowWhenNotAuthed = path === "/login" || path === "/register";

    // ✅ รอเช็ค session ก่อน
    if (session.loading) {
        return (
            <div className="min-h-screen grid place-items-center bg-white">
                <div className="flex items-center gap-3 rounded-2xl bg-white border border-slate-200 px-5 py-4 shadow">
                    <div className="h-5 w-5 animate-spin rounded-full border-2 border-emerald-600 border-t-transparent" />
                    <div className="text-[14px] text-slate-700">กำลังตรวจสอบบัญชี…</div>
                </div>
            </div>
        );
    }

    // ✅ login แล้ว ผ่านหมด
    if (session.isAuthenticated) return <Outlet />;

    // ✅ ยังไม่ login: ให้เข้าได้แค่ login/register
    if (allowWhenNotAuthed) return <Outlet />;

    // ✅ หน้าอื่นเด้งไป login (จำ path เดิมไว้)
    return <Navigate to="/login" replace state={{ from: location }} />;
}
